var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(-1283.000000, -3387.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 2572.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.7071,815.292886 C1284.31659,814.902371 1283.6834,814.902371 1283.29289,815.292886 C1282.90237,815.683401 1282.90237,816.316587 1283.29289,816.707102 L1287.58579,821 L1283.29289,825.292898 C1282.90237,825.683413 1282.90237,826.316599 1283.29289,826.707114 C1283.6834,827.097629 1284.31659,827.097629 1284.7071,826.707114 L1289.70711,821.707108 C1290.09763,821.316593 1290.09763,820.683407 1289.70711,820.292892 L1284.7071,815.292886 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftRightArrow);
export default __webpack_public_path__ + "static/media/shift-right-arrow.51041b456e1cdf3d4b3aead09ca0c4ab.svg";
export { ForwardRef as ReactComponent };